'use strict';
import { SignupBase } from './SignupBase';
import Render from './SignupRender';

class Signup extends SignupBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

export default Signup;